export const getStatusColor = (status: string) => {
  switch (status) {
    case "DRAFT":
      return "#FF9F72";
    case "EMAIL_SENT":
      return "#00AFC2";
    case "APPROVED":
      return "#00AFC2";
    case "APPROVAL_PENDING":
      return "#00AFC2";
    case "CREATED":
      return "#00AFC2";
    case "CANCELLED":
      return "#EC595C";
    case "INVOICED":
      return "#5AB77F";
    case "PAID":
      return "#5AB77F";
    case "CONVERTED":
      return "#5AB77F";
    case "PARTIALLY_PAID":
      return "#FF9F72";
    case "OVERDUE":
      return "#9c27b0";
    case "PARTIALLY_PAID_OVERDUE":
      return "#673AB7";
    case "SETTLED":
      return "#fa43b1";
    case "ISSUED":
      return "#00AFC2";
    case "CLOSED":
      return "#9c27b0";
    case "Invoice":
      return "#EC595C";
    case "Receipt":
      return "#00AFC2";
    case "Credit Note":
      return "#5AB77F";
    case "IT_TDS":
      return "#9c27b0";
    case "GST_TDS":
    case "GST TDS":
      return "#0369A1";
    case "AVAILABLE":
      return "#047857";
    case "UNAVAILABLE":
      return "#64748B";
    case "RECEIVED":
      return "#047857";
    case "NOTRECEIVED":
      return "#64748B";
    default:
      return "#f5f5f5";
  }
};

export const getReceiptColor = (status: string) => {
  switch (status) {
    case "CREATED":
      return "#00AFC2"
    case "CANCELLED":
      return "#EC595C"
  }
}
